import React from "react";

const PaymentTerms = ({
  onClickFn = () => {},
  width = "15",
  height = "20",
  fill = "currentColor",
}) => {
  return (
    <svg
      className="cursor-pointer"
      onClick={onClickFn}
      width={width}
      height={height}
      viewBox="0 0 15 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3246_127)">
<path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM2.5 3.125C2.5 2.78125 2.78125 2.5 3.125 2.5H5.625C5.96875 2.5 6.25 2.78125 6.25 3.125C6.25 3.46875 5.96875 3.75 5.625 3.75H3.125C2.78125 3.75 2.5 3.46875 2.5 3.125ZM2.5 5.625C2.5 5.28125 2.78125 5 3.125 5H5.625C5.96875 5 6.25 5.28125 6.25 5.625C6.25 5.96875 5.96875 6.25 5.625 6.25H3.125C2.78125 6.25 2.5 5.96875 2.5 5.625ZM7.5 8.4375C7.84375 8.4375 8.125 8.71875 8.125 9.0625V9.73828C8.45703 9.78516 8.77734 9.85938 9.06641 9.9375C9.39844 10.0273 9.59766 10.3672 9.50781 10.7031C9.41797 11.0391 9.07812 11.2344 8.74219 11.1445C8.30859 11.0273 7.88281 10.9414 7.48828 10.9375C7.16016 10.9336 6.80859 11.0078 6.56641 11.1523C6.34375 11.2852 6.25 11.4375 6.25 11.6523C6.25 11.7969 6.30078 11.9062 6.53516 12.0469C6.80469 12.207 7.18359 12.3242 7.67578 12.4727L7.69531 12.4766C8.13672 12.6094 8.68359 12.7734 9.11328 13.0469C9.58594 13.3438 9.98828 13.8164 10 14.5391C10.0117 15.293 9.625 15.8398 9.10547 16.1641C8.80469 16.3516 8.46484 16.4609 8.125 16.5195V17.1875C8.125 17.5312 7.84375 17.8125 7.5 17.8125C7.15625 17.8125 6.875 17.5312 6.875 17.1875V16.4922C6.4375 16.4102 6.02734 16.2695 5.66797 16.1445C5.58594 16.1172 5.50391 16.0898 5.42578 16.0625C5.09766 15.9531 4.92188 15.5977 5.03125 15.2734C5.14062 14.9492 5.49609 14.7695 5.82031 14.8789C5.91797 14.9102 6.00781 14.9414 6.09766 14.9727C6.62891 15.1523 7.05859 15.3008 7.51562 15.3125C7.87109 15.3242 8.21484 15.2461 8.44141 15.1055C8.64062 14.9805 8.75 14.8203 8.74609 14.5586C8.74219 14.3789 8.67578 14.2539 8.44531 14.1055C8.17969 13.9375 7.80078 13.8164 7.3125 13.668L7.25 13.6484C6.82031 13.5195 6.30078 13.3633 5.89062 13.1133C5.42188 12.832 5.00781 12.375 5.00391 11.6562C5 10.8984 5.42578 10.375 5.93359 10.0742C6.22656 9.90234 6.55078 9.79297 6.875 9.73438V9.0625C6.875 8.71875 7.15625 8.4375 7.5 8.4375Z" fill={fill}/>
</g>
<defs>
<clipPath id="clip0_3246_127">
<path d="M0 0H15V20H0V0Z" fill={fill}/>
</clipPath>
</defs>
    </svg>
  );
};

export default PaymentTerms;